angular.module('bribac.actions.collection', [])

  .constant('collectionActions', {
    ADD: function(kind, entities) {
      return {
        type: 'COLLECTION.ADD.' + kind,
        payload: {entities: Array.isArray(entities) ? entities : [entities]}
      }
    },

    UPDATE: function(kind, entities) {
      return {
        type: 'COLLECTION.UPDATE.' + kind,
        payload: {entities: Array.isArray(entities) ? entities : [entities]}
      }
    },

    REMOVE: function(kind, ids) {
      return {
        type: 'COLLECTION.REMOVE.' + kind,
        payload: {ids: Array.isArray(ids) ? ids : [ids]}
      }
    }
  })
